import { Box, MenuItem } from '@mui/material';
import {
  DialogTitle,
  CustomTextField,
  CustomSelect,
  HorizontalForm,
  VerticalForm,
} from '../../../common';

const ContactDataSection = ({
  selectedSubscriber,
  onInputChange,
  onSelectChange,
  isMobile,
  editMode,
  countries,
  provinces,
  departments,
  districts,
}) => {
  const getFilteredProvinces = () => {
    return provinces.filter((prov) => prov.uuid_country === selectedSubscriber.uuid_country);
  };

  const getFilteredDepartments = () => {
    return departments.filter((dep) => dep.uuid_province === selectedSubscriber.uuid_province);
  };

  const getFilteredDistricts = () => {
    return districts.filter((dist) => dist.uuid_department === selectedSubscriber.uuid_department);
  };

  if (isMobile) {
    return (
      <Box>
        <DialogTitle showSeparator={false}>Datos de Contacto</DialogTitle>
        <VerticalForm>
          <CustomTextField
            label="Dirección"
            name="address"
            value={selectedSubscriber.address || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Código Postal"
            name="postal_code"
            value={selectedSubscriber.postal_code || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Teléfono"
            name="phone"
            value={selectedSubscriber.phone || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Email"
            name="email"
            value={selectedSubscriber.email || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomSelect
            label="País"
            name="uuid_country"
            value={selectedSubscriber.uuid_country || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {countries.map((country) => (
              <MenuItem key={country.uuid} value={country.uuid}>
                {country.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Provincia"
            name="uuid_province"
            value={selectedSubscriber.uuid_province || ''}
            onChange={onSelectChange}
            disabled={!selectedSubscriber.uuid_country}
            size="medium"
          >
            {getFilteredProvinces().map((prov) => (
              <MenuItem key={prov.uuid} value={prov.uuid}>
                {prov.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Departamento"
            name="uuid_department"
            value={selectedSubscriber.uuid_department || ''}
            onChange={onSelectChange}
            disabled={!selectedSubscriber.uuid_province}
            size="medium"
          >
            {getFilteredDepartments().map((dep) => (
              <MenuItem key={dep.uuid} value={dep.uuid}>
                {dep.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Distrito"
            name="uuid_district"
            value={selectedSubscriber.uuid_district || ''}
            onChange={onSelectChange}
            disabled={!selectedSubscriber.uuid_department}
            size="medium"
          >
            {getFilteredDistricts().map((dist) => (
              <MenuItem key={dist.uuid} value={dist.uuid}>
                {dist.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </VerticalForm>
      </Box>
    );
  }

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos de Contacto
      </DialogTitle>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Dirección"
            name="address"
            value={selectedSubscriber.address || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Código Postal"
            name="postal_code"
            value={selectedSubscriber.postal_code || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Teléfono"
            name="phone"
            value={selectedSubscriber.phone || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Email"
            name="email"
            value={selectedSubscriber.email || ''}
            onChange={onInputChange}
            size="medium"
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomSelect
            label="País"
            name="uuid_country"
            value={selectedSubscriber.uuid_country || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {countries.map((country) => (
              <MenuItem key={country.uuid} value={country.uuid}>
                {country.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Provincia"
            name="uuid_province"
            value={selectedSubscriber.uuid_province || ''}
            onChange={onSelectChange}
            disabled={!selectedSubscriber.uuid_country}
            size="medium"
          >
            {getFilteredProvinces().map((prov) => (
              <MenuItem key={prov.uuid} value={prov.uuid}>
                {prov.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Departamento"
            name="uuid_department"
            value={selectedSubscriber.uuid_department || ''}
            onChange={onSelectChange}
            disabled={!selectedSubscriber.uuid_province}
            size="medium"
          >
            {getFilteredDepartments().map((dep) => (
              <MenuItem key={dep.uuid} value={dep.uuid}>
                {dep.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Distrito"
            name="uuid_district"
            value={selectedSubscriber.uuid_district || ''}
            onChange={onSelectChange}
            disabled={!selectedSubscriber.uuid_department}
            size="medium"
          >
            {getFilteredDistricts().map((dist) => (
              <MenuItem key={dist.uuid} value={dist.uuid}>
                {dist.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </Box>
      </HorizontalForm>
    </Box>
  );
};

export default ContactDataSection;
